import { render, staticRenderFns } from "./InfoCardOther.vue?vue&type=template&id=58a1077d&scoped=true&"
import script from "./InfoCardOther.vue?vue&type=script&lang=js&"
export * from "./InfoCardOther.vue?vue&type=script&lang=js&"
import style0 from "./InfoCardOther.vue?vue&type=style&index=0&id=58a1077d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a1077d",
  null
  
)

export default component.exports